(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/package-puff/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/package-puff/assets/javascripts/render-component.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const isServer = typeof exports === 'object';
let logger;
if (isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('banner_layout: package-puff');
} else {
  logger = svs.core.log.getLogger('banner_layout: package-puff');
}
const layoutType = 'package_puff';
let formatCurrency;
let bannerHelpers;
let getMixenPackageConfig;

const renderComponent = async (model, widget, position, req, res) => {
  const {
    callToActions,
    images,
    id,
    layoutConfig,
    targetOffer
  } = model;
  const {
    contentType,
    features,
    hbsCompiled,
    isAdmin,
    trackingString
  } = bannerHelpers.getRCTools({
    layoutType,
    model,
    res,
    req,
    tracking: {
      widget,
      position
    }
  });
  const {
    price,
    data: {
      packageName,
      packageContent,
      games,
      hasTicket
    }
  } = bannerHelpers.getMixenData(getMixenPackageConfig(), layoutConfig);
  if (!packageName) {
    logger.warn('Banner package-puff: Corrupt or missing mixen data from helper.');
    return null;
  }

  const actionTitle = "Betala ".concat(formatCurrency(price), " kr");
  const actionConfig = _objectSpread(_objectSpread({}, callToActions[0].actionConfig), {}, {
    quickplayTitle: actionTitle,
    bannerLayoutType: 'package_puff',
    bannerDataType: 'mixenPackages',
    packageId: layoutConfig.package,
    bannerId: id
  });
  const callToAction = bannerHelpers.getCallToAction(_objectSpread(_objectSpread({}, callToActions[0]), {}, {
    actionConfig
  }), {
    block: false,
    focus: true
  });
  return hbsCompiled(_objectSpread(_objectSpread({}, layoutConfig), {}, {
    callToAction,
    contentType,
    features,
    hasTicket,
    heading: bannerHelpers.groupNumbers(packageName),
    packageContent,
    id,
    images,
    isAdmin,
    targetOffer,
    games,
    trackingString
  }));
};
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  const format = trinidadCore.components.require('utils', 'format').api;
  formatCurrency = format.Currency;
  bannerHelpers = trinidadCore.components.require('banner_common', 'banner-helpers');
  getMixenPackageConfig = () => {
    var _trinidadCore$config$;
    return (_trinidadCore$config$ = trinidadCore.config.options.cms) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.mixenPackages;
  };
  module.exports = {
    renderComponent
  };
} else {
  bannerHelpers = svs.banner_common.banner_helpers;
  formatCurrency = svs.utils.format.Currency;
  getMixenPackageConfig = () => svs.banner_layouts.package_puff.data.mixenPackages;
  Object.assign(svs.banner_layouts.package_puff, {
    renderComponent
  });
}

 })(window);